performance.mark('app-start');
import { markAppTiming } from '@app/utilities/appTiming';
import '@app/styles/layers.scss';
import { usesContextArchitecture } from '../architecture';
import { connectRuntime } from '../connect-runtime';

markAppTiming('sportsbook:module-evaluated');
window.addEventListener('load', () => markAppTiming('sportsbook:window-load'), { once: true });

const runtime = await connectRuntime();
markAppTiming('sportsbook:runtime-connected');
const tenantId = runtime.tenantContext.queries.getTenantId();

if (usesContextArchitecture(tenantId)) {
  const { bootContextSportsbook } = await import('./context');
  bootContextSportsbook(runtime);
} else {
  window.isRecommendedBetslipsIntegratedAsMicroFrontend = false;
  await import('./classic');
}